import './App.css';
import './theme/style.css';
import { useMemo } from "react";
import BuildTheme from "./theme";
import store from "./store";
import Login from "./pages/Login";
import { routes } from "./routes/PrivateRoute";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material";
import AppLayout from "./layouts/AppLayout";
import Install from "./pages/Install";
import AuthLayout from "./layouts/AuthLayout";

function App() {
  const theme = useMemo(() => BuildTheme('light'), []);

  const privateRoutes = useMemo(() => {
    return routes.map(({ component: Component, ...props }, i) => (
      <Route key={i} {...props} element={<Component {...props} />} />
    ));
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<AuthLayout />}>
              {/* The login page loads by default */}
              <Route index element={<Login />} />
             
            </Route>
            <Route path="/app" element={<AppLayout />}>
              {privateRoutes}
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
